import styled from "styled-components";
import designSystemColors from "../../styles";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Paragraph = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${designSystemColors.textDark};
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 16px;
  border-top: 1px solid ${designSystemColors.border.modalDivider};
  padding-top: 16px;

  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
